<template>
  <div id="DummyRegistModal" style="width: 90%;height:60%;margin-left: 10%;margin-top: 2%;">
    <div class="modal-card" style="width: 90%;height:600px;">
      <header class="modal-card-head">
        <p class="modal-card-title" style="color: whitesmoke; text-align:left">
          <b>　暫定ユーザーから本登録ユーザーに変更します。</b><br>
          <br>・本登録をすると、外部の顧客から、アクセスが可能となります。
          <br>　情報漏洩のリスクに十分注意してください。
          <br>　更新する情報の誤りがないか確認のうえ、【OK】ボタンを
          <br>　押してください。</p>
      </header>
      <section class="modal-card-body">
        <!--表示情報 -->
        <div class="condition-area">
          <table class="dummyTable">
            <tr>
              <th style="width:20%">施設名</th>
              <td style="width:75%"> 
                <input style="border: none" type="text" class="nameInput" v-model="belongs.medicalInstitutionName" disabled/>
              </td>
              <td style="width:5%">
                <b-checkbox  class="medicalCheckBox" v-model="isMedicalName" value="false"></b-checkbox>
              </td>
            </tr>
            <tr>
              <th>住所</th>
              <td>
                <input style="border: none" type="text" class="addressInput" :value="address" disabled>
              </td>
              <td>
                <b-checkbox  class="adressCheckBox" v-model="isAddress" value="false"></b-checkbox>
              </td>
            </tr>
            <tr>
              <th>得意先コード</th>
              <td>
                <input style="border: none" type="text" class="nameInput" v-model="belongs.customerId" disabled/>
              </td>
              <td>
                <b-checkbox  class="codeCheckBox" v-model="isMedicalCode" value="false"></b-checkbox>
              </td>
            </tr>
            <tr>
              <th>担当営業所</th>
              <td>
                <input style="border: none" type="text" class="nameInput" v-model="salesOfficeName" disabled/>
              </td>
              <td>
                <b-checkbox  class="salesOfficeCheckBox" v-model="isSalesOffice" value="false"></b-checkbox>
              </td>
            </tr>
            <tr>
              <th>担当者</th>
              <td>
                <input style="border: none" type="text" class="nameInput" v-model="belongs.salesStaffName" disabled/>
              </td>
              <td>
                <b-checkbox  class="salesStaffCheckBox" v-model="isSalesStaff"></b-checkbox>
              </td>
            </tr>
          </table>
        </div>
      </section>
      <footer class="modal-card-foot custom-footer">
        <button class="button" type="button" @click="$parent.close()">戻る</button>
        <button class="button ok-button" type="button" @click="save" :disabled="singleCheck()">OK</button>
      </footer>
    </div>
  </div>
</template>
<script>

export default {
  name: "DummyRegistModal",
  props: {
    belongs:{default: "", }
  },
  methods: {
    singleCheck: function() {
      if(this.isMedicalName && this.isAddress && this.isMedicalCode && this.isSalesOffice && this.isSalesStaff){
        return false
      }
      return true
    },
    save: function() {
      var okFlag = true
      this.$emit('select', okFlag);
      this.$parent.close();
    },
  },

  data() {
    var salesOfficeMaster = this.getSalesOfficeMaster();
    salesOfficeMaster.unshift({});
    var salesOfficeInfo = salesOfficeMaster.find(item => item.code === this.belongs.salesOfficeCode);
    var salesOfficeName = salesOfficeInfo.name;

    return {
      salesOfficeMaster:salesOfficeMaster,
      isMedicalName: false,
      isAddress: false,
      isMedicalCode: false,
      isSalesOffice: false,
      isSalesStaff: false,
      salesOfficeName: salesOfficeName,
    };
  },
  filters: {},
  components: {},
  mounted: function () {
    okButton = disabled = true
    this.getDepositoryCodeMaster()
  },
  computed: {
    address: function() {
      return `${this.belongs.customerPostCode} ${this.belongs.prefecture} ${this.belongs.city} ${this.belongs.customerAddress1} ${this.belongs.customerAddress2}`
    },
  }
};
</script>
<style lang="scss" scoped>
.customRadio {
  width:10px;
}
.result-area {
  height: 450px;
}
table.dummyTable {
  border: none;
  border-collapse: collapse;
  width: 100%;
}
table.dummyTable > tr {
  border: none;
  height: 30px;
}
table.dummyTable >tr> th,
table.dummyTable >tr> td {
  border: none;
  vertical-align : middle;
  padding:5px;
}
table.dummyTable >tr> th {
  background-color: #cfdbea;
  text-align: center;
  font-weight: bold; 
  width: 100px;
}
table.dummyTable >tr> td {
  width: 200px;
}
.addressInput {
  width: 100% !important;
}
.address2Input {
  width: 12% !important;
}
.address3Input {
  width: 18% !important;
}
.address4Input {
  width: 20% !important;
}
.address5Input {
  width: 40% !important;
}
.custom-footer {
  position: relative;
  display: flex;
  align-items: center;
}
.ok-button {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}

</style>


// WEBPACK FOOTER //
// src/components/mock/philips/common/DummyRegistModal.vue